import { render } from "./BsHfCard.vue?vue&type=template&id=d9c8ae54&scoped=true"
import script from "./BsHfCard.vue?vue&type=script&lang=js"
export * from "./BsHfCard.vue?vue&type=script&lang=js"

import "./BsHfCard.vue?vue&type=style&index=0&id=d9c8ae54&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d9c8ae54"

export default script